import { render } from "./HelloWorld.vue?vue&type=template&id=ea15ad14&scoped=true"
import script from "./HelloWorld.vue?vue&type=script&lang=js"
export * from "./HelloWorld.vue?vue&type=script&lang=js"

import "./HelloWorld.vue?vue&type=style&index=0&id=ea15ad14&scoped=true&lang=scss"

import exportComponent from "D:\\XGprogect\\海尔会员\\haierhuiyuan-phone\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea15ad14"]])

export default __exports__